import { render } from "./Test.vue?vue&type=template&id=0d72c53b"
const script = {}
script.render = render

export default script